import axios from 'axios';
import { clearStoredAuth, getStoredAuthToken } from './authToken';

const apiClient = axios.create({
  baseURL: 'https://cafeappmore.com/api',
});

apiClient.interceptors.request.use((config) => {
  const token = getStoredAuthToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredAuth();
      const isAdminPath = window.location.pathname.startsWith('/admin');
      const loginPath = isAdminPath ? '/admin/login' : '/appmanage/login';
      if (window.location.pathname !== loginPath) {
        window.location.assign(loginPath);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
